import React, { useEffect, useState } from "react";
import { Menu } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import gridSvg from "../assets/svg/eye.svg"; 

const icons = {
  gridSvg, 
};
function getItem(label, key, icon, children, type) {
  return {
    key,
    icon,
    children,
    label,
    type,
  };
}

const menuData = [
  {
    dymId: "1",
    dymLink: "dashboard",
    dymLabel: "dashboard",
    mnOwner: "ALL",
    mnParentId: null,
    dymIcon: gridSvg,
    children: [],
  },
   {
    dymId: "2",
    dymLink: "datasets",
    dymLabel: "Dataset",
    mnOwner: "ALL",
    mnParentId: null,
    dymIcon: gridSvg,
    children: [],
  },
]
export default function SideBarClosed() {
  const { sideMenuCollapsed } = useSelector((state) => state.global);
  const { user } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const generateMenuItems = (menuData) => {
    if (user?.changePassword === true || user?.changePassword === null) {
      return [];
    }
    const mapItems = (items, isChild) => {
      return items?.map((item) => {
        if (item?.isTitle) {
          return {
            key: item?.dymId,
            label: item?.dymLabel,
            type: "group",
          };
        }
        const iconSrc = icons[item?.dymIcon] || gridSvg;
        return getItem(
          item?.dymLabel?.charAt?.(0)?.toUpperCase() + item?.dymLabel?.slice(1),
          item?.dymLink,
          !isChild ? <img src={iconSrc} alt={item?.dymIcon} /> : null,
          item?.children && item?.children?.length > 0
            ? mapItems(item?.children, true)
            : null
        );
      });
    };
    if (!menuData || menuData?.length === 0) {
      return [];
    }

    return mapItems(menuData);
  };
  const items = [
    ...generateMenuItems(menuData),

    {
      type: "divider",
    },
  ];

  const location = useLocation();
  const currentPath = location.pathname;

  const [lastSelectedKey, setLastSelectedKey] = useState(null);

  const handleNavigation = async (e) => {
    await setLastSelectedKey(e.key);
    await navigate(e?.key);
  };

  const selectedKeyFromPath = currentPath?.replace("/", "");
  const validKeys = menuData?.map((item) => item?.dymLink);
  const selectedKey = validKeys?.includes(selectedKeyFromPath)
    ? selectedKeyFromPath
    : lastSelectedKey;

  useEffect(() => {}, [sideMenuCollapsed]);

  return (
    <>
      <div
        style={{
          borderInlineEnd: "1px solid rgba(5, 5, 5, 0.06)",
        }}
        className="flex flex-col h-full bg-[#f4f5f7] pt-[4.5rem]"
      >
        <Menu
          onClick={handleNavigation}
          selectedKeys={selectedKey ? [selectedKey] : []}
          // defaultSelectedKeys={["dash", "/dashboard"]}
          defaultOpenKeys={[]}
          mode="inline"
          theme="light"
          inlineCollapsed={sideMenuCollapsed}
          items={items}
        />
      </div>
    </>
  );
}
